/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Download_InvoiceInputs */

const en_download_invoice = /** @type {(inputs: Download_InvoiceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Download`)
};

const fr_download_invoice = /** @type {(inputs: Download_InvoiceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Télécharger`)
};

const de_download_invoice = /** @type {(inputs: Download_InvoiceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Herunterladen`)
};

const it_download_invoice = /** @type {(inputs: Download_InvoiceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Scaricamento`)
};

const ru_download_invoice = /** @type {(inputs: Download_InvoiceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Скачать`)
};

const es_download_invoice = /** @type {(inputs: Download_InvoiceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Descargar`)
};

const zh_cn2_download_invoice = /** @type {(inputs: Download_InvoiceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`下载`)
};

const ja_download_invoice = /** @type {(inputs: Download_InvoiceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ダウンロード`)
};

const hi_download_invoice = /** @type {(inputs: Download_InvoiceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`डाउनलोड करना`)
};

const pt_pt2_download_invoice = /** @type {(inputs: Download_InvoiceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Download`)
};

/**
* | output |
* | --- |
* | "Download" |
*
* @param {Download_InvoiceInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const download_invoice = /** @type {((inputs?: Download_InvoiceInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Download_InvoiceInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_download_invoice(inputs)
	if (locale === "de") return de_download_invoice(inputs)
	if (locale === "it") return it_download_invoice(inputs)
	if (locale === "ru") return ru_download_invoice(inputs)
	if (locale === "es") return es_download_invoice(inputs)
	if (locale === "zh-CN") return zh_cn2_download_invoice(inputs)
	if (locale === "ja") return ja_download_invoice(inputs)
	if (locale === "hi") return hi_download_invoice(inputs)
	if (locale === "pt-PT") return pt_pt2_download_invoice(inputs)
	return en_download_invoice(inputs)
});